import { math } from "noood/util/math/math";
export var __convert_byte = function __convert_byte(bytes) {
  var units = ['Bytes', 'Kb', 'Mb', 'Gb'];
  var division_count = 0;
  var DIVISOR = 1024;
  if (bytes > DIVISOR) {
    var new_unit = bytes;
    do {
      new_unit = new_unit / DIVISOR;
      division_count++;
    } while (new_unit > DIVISOR);
    return "".concat(math.round(new_unit * 100 / 100, 2), " ").concat(units[division_count]);
  } else {
    return "".concat(bytes, " Bytes");
  }
};
export var __percentToHex = function __percentToHex(percent) {
  return Math.floor(percent / 100 * 255).toString(16);
};

/**
 * @param queryString
 * @param keyToModify
 * @param newValue
 * @param additionalParams
 */
export var queryStringModifier = function queryStringModifier(_ref) {
  var queryString = _ref.queryString,
    modifiers = _ref.modifiers;
  if (typeof modifiers === 'string') return modifiers;
  var params = new URLSearchParams(queryString);
  Object.keys(modifiers).forEach(function (k) {
    if (modifiers[k] === void 0) {
      params["delete"](k);
    } else {
      params.set(k, modifiers[k]);
    }
  });
  return "?".concat(params.toString());
};
export var queryStringMod = function queryStringMod(mods) {
  if (typeof mods === 'string') return mods;
  var params = new URLSearchParams(document.location.search);
  Object.keys(mods).forEach(function (k) {
    if (mods[k] === void 0) {
      params["delete"](k);
    } else {
      params.set(k, mods[k]);
    }
  });
  return "?".concat(params.toString());
};